// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #1394ff;
  --black: #282828;
  --gray: #e2e4e6;
  --dark-gray: gray;
  --white: #ffffff;
  --light-gray: #d3d3d3;
  --orange: #ff8f00;
  --bg-color: var(--white);
  --header_height: 60px;
  --header_bg_color: var(--black);
  --header_font_color: white;
  --autocomplete_btn_search_bg_color: var(--blue);
  --autocomplete_btn_search_font_color: white;
  --autocomplete_box_height: 40px;
  --theme: var(--blue);
  --rating-bar-color: #3c3b3b;
  --btn-color: var(--black);
  --address_desc_color: #afafaf;
  --address_title_color: #333;
  --address_bg_color: white;
  --fill_color_svg_mobile: #9A9A9A;
  --stroke_color_svg_mobile: white;
}

.backdrop {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
}

#popup {
  background-color: white;
  min-height: 300px;
  max-height: calc(100vh - 100px);
  position: relative;
  width: 700px;
  max-width: calc(100vw - 40px) !important;
  /*overflow-y: auto;*/
}

.modal-body {
  padding: 0px;
  position: relative;
}

.modal-title {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
  letter-spacing: 1.5px;
  color: rgba(0, 0, 0, 0.6);
  font-family: "Inter", sans-sarif;
}

.btn-close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
  opacity: 0.8;
  cursor: pointer;
}

.btn-close:hover {
  opacity: 1;
}

.body {
  padding: 20px;
  /* max-height: calc(100vh - 110px); */
  overflow-y: auto;
  /* overflow-y: scroll; */
}

.footer {
  text-align: right;
  padding: 0px 20px 20px 20px;
}

button {
  outline: 0px;
}

@media (max-width: 330px) {
  .footer {
    text-align: right;
    padding: 0px 5px 10px 0px;
  }
}
@media (max-width: 440px) {
  #popup {
    margin-top: 10px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
